module.exports = __webpack_public_path__ + "img/status-wallet.1081f8a8.png";